import { render, staticRenderFns } from "./pesquisar.vue?vue&type=template&id=3d1f3796&scoped=true"
import script from "./pesquisar.vue?vue&type=script&lang=js"
export * from "./pesquisar.vue?vue&type=script&lang=js"
import style0 from "./pesquisar.vue?vue&type=style&index=0&id=3d1f3796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f3796",
  null
  
)

export default component.exports